module.exports = __webpack_public_path__ + "static/media/Ayandeh.1b4649c1.svg";